import { render, staticRenderFns } from "./certificateDetail.vue?vue&type=template&id=f51ea24c&scoped=true&"
import script from "./certificateDetail.vue?vue&type=script&lang=js&"
export * from "./certificateDetail.vue?vue&type=script&lang=js&"
import style0 from "./certificateDetail.vue?vue&type=style&index=0&id=f51ea24c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51ea24c",
  null
  
)

export default component.exports